import gql from 'graphql-tag';
import { AgentFragment } from '../fragments';

export default gql`
  mutation updateProfile($input: UpdateOneAgentInput) {
    __typename
    agentUpdateOne(input: $input) {
      ...AgentFragment
    }
  }
  ${AgentFragment}
`;
